
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiElectricGeneratorOrMotor as ObiElectricGeneratorOrMotorElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-electric-generator-or-motor.js';
 
 
 

 
 export const ObiElectricGeneratorOrMotor = createComponent({
   react: React,
   tagName: 'obi-electric-generator-or-motor',
   elementClass: ObiElectricGeneratorOrMotorElement,
   events: {
     
   }
  });
 
 